import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TppCommonService } from '@nspk/tpp-front-commons';
import { RequestService } from '../../../services/request.service';
import { Subscription } from 'rxjs';
import { PickACardDto } from '../../../dto/pickACard.dto';
import { BackUrlDto } from '../../../dto/back-url.dto';
import MobileDetect from 'mobile-detect';
import { DialogService } from 'primeng/dynamicdialog';
import { TokenInfoComponent } from '../../../components/token-info/token-info.component';
import { ICardToPick } from '../../../models/card-to-pick.interface';

@Component({
    standalone: false,
    selector: 'app-pick',
    templateUrl: './pick.component.html',
    styleUrls: ['./pick.component.scss']
})
export class PickComponent implements OnInit, OnDestroy {

    loading: boolean;

    isMobile: boolean;

    tooltipText: string;

    form: UntypedFormGroup;

    /**
     * Массив доступных для выбора носителей
     */
    mediums: ('TAN' | 'PAN')[];

    /**
     * Тип отображения страницы, получаемый из mediums ответа
     */
    pageType: 'TAN' | 'PAN' | 'TANPAN';

    card: ICardToPick;

    subscriptions: Subscription;

    needToCreateToken = false;

    constructor(
        private router: Router,
        private tppCommonService: TppCommonService,
        private requestService: RequestService,
        private dialogService: DialogService
    ) {
    }

    ngOnInit(): void {
        this.subscriptions = new Subscription();

        this.form = new UntypedFormGroup({
            cardId: new UntypedFormControl('', Validators.required)
        });

        this.fetchCardInfo();

        this.defineDeviceType();

        window.addEventListener('resize', this.defineDeviceType.bind(this));

        this.tooltipText = `Доступно только для владельцев смартфонов на Android
                                <ol>
                                    <li>Откройте Mir Pay</li>
                                    <li>Выберите в нижнем меню раздел &laquo;Карты&raquo;</li>
                                    <li>Выберите нужную карту из списка</li>
                                    <li>Посмотрите &laquo;Виртуальный номер карты&raquo;</li>
                                </ol>`;
    }

    updateCardInfo() {
        this.fetchCardInfo();
    }

    redirectToInstruction() {
        this.tppCommonService.setCookie('redirectToMirOnline', true);
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['/redirect'])
        );

        window.open(url, '_blank');
    }

    submitForm() {
        if (this.form.valid) {
            this.loading = true;
            this.subscriptions.add(
                this.requestService.post<BackUrlDto>('/applicants/pick-a-card', { cardId: this.form.get('cardId').value })
                    .subscribe(res => {
                        if (res?.backUrl) {
                            window.location.href = res.backUrl;
                        } else {
                            this.tppCommonService.setCookie('gsRequestError', true);
                            this.router.navigate(['/error']);
                        }
                    })
            );
        } else {
            this.form.markAllAsTouched();
        }

    }

    /**
     * Определеяет, использует ли клиент мобильный браузер
     */
    defineDeviceType() {
        this.isMobile = Boolean(new MobileDetect(window.navigator.userAgent).mobile());
    }

    showInfoModal() {
        if (this.isMobile) {
            const ref = this.dialogService.open(TokenInfoComponent, {
                width: '90%',
                styleClass: 'p-dialog_no-header-line'
            });

        }
    }

    ngOnDestroy(): void {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
            this.subscriptions = null;
        }

        window.removeEventListener('resize', this.defineDeviceType.bind(this));
    }

    /**
     * Получение информации о карте и токенах, доступных для использования в качестве платежного средства по льготе
     *
     * @private
     */
    private fetchCardInfo() {
        this.loading = true;

        this.subscriptions.add(this.requestService.get<PickACardDto>('/applicants/pick-a-card').subscribe((res) => {
            this.card = res.card;

            this.mediums = res.mediums;

            this.pageType = res.mediums?.length === 2 ? 'TANPAN' : res.mediums[0];

            const cardIdFormControl = this.form.get('cardId');

            if (this.pageType === 'TAN' && this.card?.tokens?.length === 1) {
                this.form.get('cardId').setValue(this.card.tokens[0].id);
            }

            if (this.pageType === 'PAN' || (this.pageType === 'TANPAN' && !this.card?.tokens?.length)) {
                this.form.get('cardId').setValue(res.card?.id);
            }

            if (this.pageType === 'TANPAN' && this.card?.tokens?.length) {
                this.form.get('cardId').setValue('');
            }

            this.needToCreateToken = false;

            this.loading = false;
        }));
    }
}
